import { useEffect } from "react";
import { SITE_URL, BIZ } from "../data/site";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const shopNode = {
  "@type": "AutoBodyShop",
  "@id": `${SITE_URL}/#business`,
  name: BIZ.name,
  url: SITE_URL,
  telephone: "+1-214-888-2886",
  email: BIZ.email,
  address: {
    "@type": "PostalAddress",
    streetAddress: BIZ.street,
    addressLocality: BIZ.city,
    addressRegion: BIZ.state,
    postalCode: BIZ.zip,
    addressCountry: "US",
  },
};

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE_URL}${it.path}`,
  })),
});

export const serviceSchema = (s) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: s.menuName || s.name,
  name: s.h1,
  description: s.metaDesc,
  url: `${SITE_URL}/services/${s.slug}`,
  provider: shopNode,
  areaServed: [
    "Carrollton", "Farmers Branch", "Addison", "Coppell",
    "Dallas", "Lewisville", "Plano", "Irving",
  ].map((c) => ({ "@type": "City", name: c })),
});

export const Seo = ({ title, description, path = "/", schemas = [], robots }) => {
  useEffect(() => {
    document.title = title;
    const url = `${SITE_URL}${path}`;
    setMeta("name", "robots", robots || "index, follow, max-image-preview:large, max-snippet:-1");
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
    document.head.querySelectorAll("script[data-seo-page]").forEach((s) => s.remove());
    schemas.forEach((schema) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo-page", "1");
      s.textContent = JSON.stringify(schema);
      document.head.appendChild(s);
    });
  }, [title, description, path, schemas]);
  return null;
};
